import script from "./ArtefactPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtefactPage.vue?vue&type=script&setup=true&lang=ts"

import "./ArtefactPage.vue?vue&type=style&index=0&id=5771b8da&lang=scss"

const __exports__ = script;

export default __exports__